import GenderStatsTable from '../../components/metrics/GenderStatsTable';

const GenderMetricsPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex flex-col gap-2 mb-6">
        <h1 className="text-2xl font-bold">Estadísticas de Género</h1>
        <p className="text-sm text-gray-500 italic">
          Muestra tasks que tengan estado no rechazado*
        </p>
      </div>
      <GenderStatsTable />
    </div>
  );
};

export default GenderMetricsPage;
